/**
 * Created by mohit.chavda on 3/9/2017.
 */
export class ListOfInfo {

  get label():string
  {
    return this.infoSource;
  };
  get value():string
  {
    return this.infoSource;
  };

  infoSourceID:number;
  infoSource:string;
  allowCustomInput:boolean;
  sortOrder:number;
}



// WEBPACK FOOTER //
// ./src/app/shared/ListOfInfo.ts